import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-acesso-nao-permitido',
  templateUrl: './acesso-nao-permitido.component.html',
  styleUrls: ['./acesso-nao-permitido.component.scss']
})
export class AcessoNaoPermitidoComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  back() {
    this.router.navigateByUrl('/');
  }
}
